import { skipToken } from '@reduxjs/toolkit/query';
import type React from 'react';
import { lazy, Suspense, useEffect } from 'react';
import { type RouteObject, useParams } from 'react-router-dom';
import { PageLoading, usePageLoading } from '@/app/components/page-loading.tsx';
import { useFetchMeetingQuery } from '@/slices/meetings-api-slice.ts';

const LazyMeeting = lazy(() => import('./Meeting.tsx'));

const Meeting = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode }) => {
  const params = useParams();
  const { data, isLoading: meetingLoading } = useFetchMeetingQuery(params?.key ?? skipToken);

  const { showPageLoading, hidePageLoading } = usePageLoading();

  useEffect(() => {
    meetingLoading
      ? showPageLoading('meeting-lazy-loading')
      : hidePageLoading('meeting-lazy-loading');
  }, [meetingLoading]);

  return (
    <Suspense fallback={<PageLoading />}>
      <LazyMeeting {...props} meeting={data} />
    </Suspense>
  );
};

export const meetingRoute = {
  path: '/meeting/:key',
  element: <Meeting />,
} as RouteObject;
export default Meeting;
